import { CHNANGE_TAB } from "../actionTypes";

const selectTabReducer = (prevState = 0, action) => {
  switch (action.type) {
    case CHNANGE_TAB:
      return action.payload;
    default:
      return prevState;
  }
};
export default selectTabReducer;